import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { URL_SERVICIOS } from 'src/app/config/config';
import { ZoomService } from 'src/app/services/zoom.service';
import { URL_DOCS } from 'src/app/config/config';

import { FormBuilder, Validators } from '@angular/forms';
import { UsuarioService } from 'src/app/services/usuario.service';
import { EncriptacionService } from 'src/app/services/encriptacion.service';
import { GeneralService } from 'src/app/services/general.service';

@Component({
  selector: 'app-lobby',
  templateUrl: './lobby.component.html',
  styleUrls: ['./lobby.component.css']
})
export class LobbyComponent implements OnInit {
  

  public id_room: any;
  public parametros_url: any;
  public entro_anfitrion: boolean = false;
  consulta: any = {};

  _usuario: any = {}; 

  limit_tips

  fade: boolean = false;

  tips: any[] = [];
  currentTipIndex: number = 0;
  tipsInterval: any;

  campaigns: any = {};

  URL_DOCUMENTS = URL_DOCS;

    pageInfo: any = {};



  public info_usuario = this.fb.group({
    use_id: ['', [Validators.required]],
    con_ana_page: ['', [Validators.required]],
    con_ana_connection_type: ['', [Validators.required]],
    con_ana_connection_mode: ['', [Validators.required]]
  });
  
  

  constructor(
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    public _usuarioService: UsuarioService,
    private http: HttpClient,
    private router: Router,
    private _zoomServices: ZoomService,
  private generalService: GeneralService)
  {
    this.activatedRoute.params.subscribe(parametros => {
      
      this.parametros_url = parametros;
      // console.log(this.parametros_url);
      
    });
    this.id_room = this.parametros_url.idReunion;
    let params = {
  id_consulta: this.parametros_url.id_consulta,
  method: 'in'
};
this._zoomServices.postUpdateStartLobby(params)
  .then(() => {})
  .catch((error) => console.log(error));

    
      this.getConsulta(this.parametros_url.id_consulta);
    
    
   }

  ngOnInit(): void {
    this.observador();

    this.getInfoTips();
    this.getInfoCampaigns();

    this._usuario = new EncriptacionService().getUserInfo();
    this.pageInfo = new EncriptacionService().getPageInfo();
    // console.log(this.pageInfo);

    var ua = navigator.userAgent;

    if(/iPhone|iPad|iPod/i.test(ua))
    {
      var connection_mode = (window.navigator['connection'] as any)?.effectiveType;
       this.info_usuario.controls['use_id'].setValue(this._usuario._id);
       this.info_usuario.controls['con_ana_page'].setValue('Sala de espera');
       this.info_usuario.controls['con_ana_connection_type'].setValue('IOS');
       this.info_usuario.controls['con_ana_connection_mode'].setValue(connection_mode);
       //console.log(this.info_usuario.value);
       this._usuarioService.infoUsuario(this.info_usuario.value)
        .subscribe( (data:any) => {
          //console.log("registro almacenado");
          
        })
       
    }
    else if(/Android|webOS|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua))
    {
      var connection_mode = (window.navigator['connection'] as any)?.effectiveType;
       this.info_usuario.controls['use_id'].setValue(this._usuario._id);
       this.info_usuario.controls['con_ana_page'].setValue('Sala de espera');
       this.info_usuario.controls['con_ana_connection_type'].setValue('Android');
       this.info_usuario.controls['con_ana_connection_mode'].setValue(connection_mode);
       //console.log(this.info_usuario.value);
       this._usuarioService.infoUsuario(this.info_usuario.value)
        .subscribe( (data:any) => {
          //console.log("registro almacenado");
          
        })
    }
    else
    {
      var connection_mode = (window.navigator['connection'] as any)?.effectiveType;
       this.info_usuario.controls['use_id'].setValue(this._usuario._id);
       this.info_usuario.controls['con_ana_page'].setValue('Sala de espera');
       this.info_usuario.controls['con_ana_connection_type'].setValue('Desktop');
       this.info_usuario.controls['con_ana_connection_mode'].setValue(connection_mode);
       //console.log(this.info_usuario.value);
       this._usuarioService.infoUsuario(this.info_usuario.value)
        .subscribe( (data:any) => {
          //console.log("registro almacenado");
          
        })
    }
  }

  getConsulta(id_consulta) {
    this._zoomServices.getConsulta(id_consulta)
      .then(result => {
        // console.log(result);
        this.consulta = result;
      })
      .catch(error => {
        console.log(error);
      });
  }


 async observador() {

  let headers = new Headers();
  const httpOptions = {
    headers: new HttpHeaders({
      'authorization': sessionStorage.getItem('token'),
      'Content-Type': 'application/json'
    })
  }; 
  let url_post = URL_SERVICIOS+'/postMeetingState';
      // console.log(this.entro_anfitrion);
      
  while (!this.entro_anfitrion) {

    this.http.post(url_post, ({ id_room: this.id_room }), httpOptions).subscribe((
      data: any[]) => {

      if (data[0].zoo_mee_active) {

  if (this.isModalOpen == false) {

    this.entro_anfitrion = true;

    // ✅ 1) Avisar que salió del lobby automáticamente
    const params = {
      id_consulta: this.parametros_url.id_consulta,
      method: 'out'
    };

    this._zoomServices.postUpdateStartLobby(params)
      .then(() => {
        // ✅ 2) Luego navegar
        var url = "mivideoconsulta/" +
          this.parametros_url.idReunion + "/" +
          this.parametros_url.id_consulta + "/" +
          this.parametros_url.med_con_id;

        this.router.navigate([url]);
      })
      .catch(error => {
        console.log('Error enviando salida automática del lobby:', error);

        // incluso si falla, puedes decidir navegar igual
        var url = "mivideoconsulta/" +
          this.parametros_url.idReunion + "/" +
          this.parametros_url.id_consulta + "/" +
          this.parametros_url.med_con_id;

        this.router.navigate([url]);
      });
  }
}

    }); 

    // console.log("No entraron");
    await this.sleep(10000);
  }
}

   sleep(ms = 0) {
    return new Promise(r => setTimeout(r, ms));
  }

  
  ngOnDestroy() {

    this.entro_anfitrion = true;
    if (this.tipsInterval) {
      clearInterval(this.tipsInterval);
    }
  }

  @HostListener('window:unload', [ '$event' ])
  unloadHandler(event) {
    this.entro_anfitrion = true;
  }

  @HostListener('window:beforeunload', [ '$event' ])
  beforeUnloadHandler(event) {
    this.entro_anfitrion = true;
  }

  clickZoomDescarga(){
    window.open('https://zoom.us/download');
  }

  startTipsRotation() {
    this.tipsInterval = setInterval(() => {
      this.fade = true; // inicia fade out
  
      setTimeout(() => {
        this.currentTipIndex = (this.currentTipIndex + 1) % this.tips.length;
        this.fade = false; // fade in
      }, 800); // tiempo que coincide con el CSS
    }, 10000);
  }
  
  

  getInfoTips() {
    this.generalService.getInfoTips().then((result: any) => {
      const tipsFiltrados = result.data?.filter((t: any) => t.con_info_type === 1) || [];
  
      this.tips = tipsFiltrados;  
      // console.log(this.tips);
      
  
      if (this.tips.length > 0) {
        this.startTipsRotation();
      }
    });
  }
  
  
  getInfoCampaigns() {
   this.generalService.getInfoCampaigns().then(result => {
     this.campaigns = result; 
    //  console.log(this.campaigns);
     
   })
  }
  isModalOpen = false;
openModal(): void {
  this.isModalOpen = true;
  // console.log(this.isModalOpen);
  
}

closeModal(): void {
  this.isModalOpen = false;
    // console.log(this.isModalOpen);

}
  
}
